// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see MarketingWebInteractScrollCarouselEvent
 */
export var MarketingWebInteractScrollCarousel = function (_a) {
    var pageName = _a.pageName, sectionName = _a.sectionName, componentType = _a.componentType, interactionType = _a.interactionType, direction = _a.direction;
    return ({
        name: "MarketingWeb Interact ScrollCarousel",
        parameters: {
            cdf_entity: "MarketingWeb",
            cdf_action: "Interact",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_name: sectionName !== undefined && sectionName !== null ? sectionName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            component_type: componentType !== undefined && componentType !== null ? componentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            interaction_type: interactionType !== undefined && interactionType !== null ? interactionType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            direction: direction !== undefined && direction !== null ? direction.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MarketingWebViewViewSectionEvent
 */
export var MarketingWebViewViewSection = function (_a) {
    var pageName = _a.pageName, sectionName = _a.sectionName, sectionIndex = _a.sectionIndex;
    return ({
        name: "MarketingWeb View ViewSection",
        parameters: {
            cdf_entity: "MarketingWeb",
            cdf_action: "View",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_name: sectionName !== undefined && sectionName !== null ? sectionName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_index: sectionIndex !== undefined && sectionIndex !== null ? sectionIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
